// extracted by mini-css-extract-plugin
export default {"control":"password-change-form_control__O3aGl","submit":"password-change-form_submit__yFqHE"};